module.exports = __webpack_public_path__ + "img/RunningDeadConceptArt4_1265x661.59575725.jpg";